export default "__VITE_ASSET__DWVOreRl__"